<template>
  <div
    class="bg-silver-70 w-full rounded-md text-white flex items-center justify-center max-h-96 h-59"
  >
    <component
      :is="ImagePlaceholderSvg"
      aria-hidden="true"
      width="7.5rem"
      height="7.5rem"
      class="inline-block"
    />
  </div>
</template>

<script setup lang="ts">
import ImagePlaceholderSvg from '~/assets/images/placeholders/image-placeholder.svg?component';
</script>
